import SelectablePill from './SelectablePill'

export default SelectablePill
